import { InvestmentCustomTagCategory } from 'further-types/investment';
import { InvestorCustomTagCategory } from 'further-types/investor';

export const InvestmentCustomTagCategoryLabels: Record<
  InvestmentCustomTagCategory,
  string
> = {
  [InvestmentCustomTagCategory.Source]: 'Source',
  [InvestmentCustomTagCategory.InternalContact]: 'Internal contact',
  [InvestmentCustomTagCategory.Other]: 'Other',
};

export const InvestorCustomTagCategoryLabels: Record<
  InvestorCustomTagCategory,
  string
> = {
  [InvestorCustomTagCategory.Source]: 'Source',
  [InvestorCustomTagCategory.InternalContact]: 'Internal contact',
  [InvestorCustomTagCategory.Other]: 'Other',
  [InvestorCustomTagCategory.InvestorGroup]: 'Investor group',
};
